import { motion } from "framer-motion";
import { ArrowUpRight, Briefcase } from "lucide-react";
import { EASE, JOB_PORTAL_URL } from "./constants";

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.9, delay, ease: EASE },
});

export const PortalHighlight = () => (
  <section aria-labelledby="portal-heading" className="px-5 py-20 sm:px-8 sm:py-28">
    <motion.div
      {...reveal()}
      data-testid="portal-highlight-card"
      className="relative mx-auto max-w-6xl overflow-hidden rounded-[2rem] border border-[#16803C]/15 bg-[#F2FAF4] px-6 py-14 sm:px-14 sm:py-20"
    >
      <div className="ag-dots pointer-events-none absolute -right-10 -top-10 h-64 w-64 rounded-full opacity-60" aria-hidden="true" />
      <div
        className="pointer-events-none absolute -bottom-40 -left-20 h-96 w-96 rounded-full"
        style={{ background: "radial-gradient(circle, rgba(22,128,60,0.16), transparent 65%)" }}
        aria-hidden="true"
      />
      <div className="relative grid items-end gap-10 md:grid-cols-[1.4fr_1fr]">
        <div>
          <motion.span
            {...reveal(0.1)}
            className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-[#16803C] shadow-sm"
            aria-hidden="true"
          >
            <Briefcase className="h-5 w-5" />
          </motion.span>
          <motion.h2
            {...reveal(0.15)}
            id="portal-heading"
            data-testid="portal-heading"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-[-0.03em] text-[#171717] sm:text-4xl lg:text-5xl"
          >
            Your Career Journey <span className="text-[#16803C]">Doesn't Have to Wait.</span>
          </motion.h2>
        </div>
        <motion.div {...reveal(0.25)}>
          <p data-testid="portal-description" className="text-base leading-relaxed text-[#555555]">
            While we're building something better, you can continue exploring agriculture jobs,
            internships, and career opportunities through the AgriYuvaa Job Portal.
          </p>
          <motion.a
            href={JOB_PORTAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="portal-cta-button"
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.97 }}
            className="ag-focus group mt-8 inline-flex items-center gap-2 rounded-full bg-[#0B5028] px-7 py-3.5 text-base font-semibold text-white shadow-[0_12px_30px_-12px_rgba(11,80,40,0.6)] transition-colors duration-300 hover:bg-[#16803C]"
          >
            Visit Our Job Portal
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
          </motion.a>
        </motion.div>
      </div>
    </motion.div>
  </section>
);
